import React from 'react';
import LegalPage from './LegalPage';
import { BRAND_NAME, CONTACT_EMAIL } from '../constants/site';

const PrivacyPage = () => (
  <LegalPage title="Política de privacidad">
    <p>
      En {BRAND_NAME} respetamos tu privacidad. Los datos que nos proporcionas a través del formulario
      de contacto (nombre, empresa, correo, teléfono y mensaje) se utilizan únicamente para
      responder a tu solicitud y dar seguimiento comercial.
    </p>
    <p>
      La información se almacena de forma segura en nuestra infraestructura en la nube. No
      vendemos ni compartimos tus datos con terceros con fines publicitarios.
    </p>
    <p>
      Si inicias sesión con Google como cliente, aplican las políticas de autenticación de Google
      además de las nuestras para el acceso a la plataforma.
    </p>
    <p>
      Puedes solicitar la actualización o eliminación de tus datos escribiendo a {CONTACT_EMAIL}.
    </p>
    <p>Última actualización: agosto 2026.</p>
  </LegalPage>
);

export default PrivacyPage;
